import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const CircularProgress = ({ progress }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        if (chartRef.current) {
            const chart = echarts.init(chartRef.current);
            
            const option = {
                backgroundColor: 'transparent',
                series: [{
                    type: 'pie',
                    radius: ['80%', '100%'],
                    center: ['50%', '50%'],
                    startAngle: 90,
                    data: [
                        {
                            value: progress,
                            name: 'Completed',
                            itemStyle: {
                                color: '#2e00ff'
                            }
                        },
                        {
                            value: 100 - progress,
                            name: 'Remaining',
                            itemStyle: {
                                color: '#d5ccff'
                            }
                        }
                    ],
                    label: {
                        show: false
                    },
                    labelLine: {
                        show: false
                    },
                    emphasis: {
                        scale: false
                    }
                }]
            };

            chart.setOption(option);

            // Handle resize
            const handleResize = () => {
                chart.resize();
            };
            window.addEventListener('resize', handleResize);

            return () => {
                chart.dispose();
                window.removeEventListener('resize', handleResize);
            };
        }
    }, [progress]);

    return (
        <div className="relative inline-flex items-center justify-center w-24 h-24">
            <div ref={chartRef} className="w-full h-full" />
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-lg font-semibold text-gray-700">
                    {Math.round(progress)}%
                </span>
                <span className="text-xs text-gray-600">Complete</span>
            </div>
        </div>
    );
};

export default CircularProgress; 